import React from 'react';
import SRError from '~/utils/errors/srError';
import { DynamicComponents } from './dynamicComponents';

export const DynamicComponentsContext = React.createContext<DynamicComponents | null>(null);

export const DynamicComponentsProvider = ({
    dynamicComponents,
    children,
}: {
    dynamicComponents: DynamicComponents;
    children: React.ReactNode;
}) => {
    return <DynamicComponentsContext.Provider value={dynamicComponents}>{children}</DynamicComponentsContext.Provider>;
};

/**
 * Hook for accessing DynamicComponentsContext.
 *
 * Dynamic components are automatically imported based on their path within the ~/plugins/packages/*pluginName* folder.
 * All dynamic components also have to be rendered from the useDynamicComponents hook, as it provides alternative
 * component definitions if needed.
 */
export const useDynamicComponents = (): DynamicComponents => {
    const dynamicComponents = React.useContext(DynamicComponentsContext);
    if (!dynamicComponents) {
        throw new SRError("UseDynamicComponents hook can't be used outside of DynamicComponentsContext");
    }
    return dynamicComponents;
};
